import { axios, Response } from '../index'

const deleteAdminById = (adminId: string): Response<null> => {
  return axios.delete(`/v1/admins/${adminId}`)
}

export default deleteAdminById
